import { PolicyTypeNames } from './Insurance';

/**
 * Mapping de coverage_code do mt-insurance-platform para labels em pt-BR.
 *
 * Codes ausentes caem no fallback do consumidor (exibe o code cru).
 *
 * Os codes plataforma ainda nao sao conhecidos com certeza ate consultarmos
 * o catalogo. Este mapa estende PolicyTypeNames (aliases legados) e adiciona
 * codes candidatos comuns. Expandir conforme o catalogo evolui.
 */
export const CoverageNames: Record<string, string> = {
  // PolicyTypes legados (fonte unica: PolicyTypeNames)
  ...PolicyTypeNames,

  // Codes candidatos plataforma (preencher conforme catalogo)
  DEATH: 'Morte',
  DEATH_BY_ACCIDENT: 'Morte por Acidente',
  ACCIDENT: 'Acidente',
  DISABILITY: 'Invalidez',
  PERMANENT_DISABILITY_BY_ACCIDENT: 'Invalidez Permanente por Acidente',
  TEMPORARY_DISABILITY: 'Invalidez Temporária',
  INCOME_LOSS: 'Perda de Renda',
  HOSPITALIZATION: 'Internação Hospitalar',
  FUNERAL_ASSISTANCE: 'Assistência Funeral',
  MQS: 'Morte Por Qualquer Causa',
  MQC: 'Morte Por Qualquer Causa',
  AUXILIO_FUNERAL: 'Auxílio Funeral',
};
